import React from "react";

export type TabRoute = { key: string; label: string };

/**
 * Segmented control — the web stand-in for mobile's react-native-tab-view
 * TabBar. Equal-width buttons on a track with a sliding indicator behind the
 * active one.
 *
 * Generic over routes so it serves both the Activity page (paging over types)
 * and the wallet coin list (paging over crypto subtypes).
 */
const ActivityTypeTabBar = ({
  routes,
  index,
  onChange,
}: {
  routes: TabRoute[];
  index: number;
  onChange: (index: number) => void;
}) => {
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowRight") onChange((index + 1) % routes.length);
    if (e.key === "ArrowLeft") onChange((index - 1 + routes.length) % routes.length);
  };

  return (
    <div
      role="tablist"
      onKeyDown={onKeyDown}
      className="relative w-full mt-1 flex bg-[#E8F3FC] dark:bg-[#1F2C36] rounded-xl p-1"
    >
      <div
        aria-hidden
        className="absolute top-1 bottom-1 left-1 bg-secondary_button rounded-lg transition-transform duration-200 ease-out"
        style={{
          width: `calc((100% - 0.5rem) / ${routes.length})`,
          transform: `translateX(${index * 100}%)`,
        }}
      />
      {routes.map((route, i) => (
        <button
          key={route.key}
          role="tab"
          aria-selected={i === index}
          tabIndex={i === index ? 0 : -1}
          onClick={() => onChange(i)}
          // `relative` (no z-index) is deliberate: it lifts the label above the
          // absolutely-positioned indicator via DOM order alone. A z-index here
          // would also lift it above any modal that doesn't set one.
          className={`relative flex-1 min-w-0 py-3 text-[13px] font-semibold rounded-lg transition-colors truncate ${
            i === index ? "text-gray-50" : "text-[#010D16] dark:text-gray-300"
          }`}
        >
          {route.label}
        </button>
      ))}
    </div>
  );
};

export default React.memo(ActivityTypeTabBar);
